// Gói ngôn ngữ tiếng Việt
export default {
    // Chung
    siteTitle: 'Hệ thống Quản lý Thông tin AI',

    // Lựa chọn ngôn ngữ
    language: 'Ngôn ngữ',
    switchToEnglish: 'Chuyển sang tiếng Anh',
    switchToChinese: 'Chuyển sang tiếng Trung',
    switchToVietnamese: 'Chuyển sang tiếng Việt',

    // Chuyển hướng xác thực
    authRedirect: {
        verifying: 'Đang xác minh thông tin đăng nhập...',
        processing: 'Đang xử lý yêu cầu đăng nhập...',
        invalidToken: 'Không nhận được thông tin đăng nhập hợp lệ',
        verificationFailed: 'Xác minh đăng nhập thất bại',
        loginSuccess: 'Đăng nhập thành công',
        getUserInfoFailed: 'Không thể lấy thông tin người dùng',
    },

    // Thanh bên
    dashboard: 'Bảng điều khiển',
    reports: 'Quản lý Báo cáo',
    templates: 'Mẫu Báo cáo',
    svgmaker: 'Văn bản sang PPT',
    settings: 'Cài đặt Hệ thống',
    onelineReport: 'Chế độ Lập kế hoạch',
    intelligenceQuery: 'Truy vấn Thông tin',
    logout: 'Đăng xuất',

    // Menu người dùng
    profile: 'Thông tin Cá nhân',
    accountSettings: 'Cài đặt Tài khoản',

    // Điều hướng
    home: 'Trang chủ',

    // Trang bảng điều khiển
    welcomeBack: 'Chào mừng trở lại',
    totalReports: 'Tổng số Báo cáo',
    newReportsThisMonth: 'Báo cáo Mới Tháng này',
    reportTemplates: 'Mẫu Báo cáo',
    templateVersions: 'Tổng số Phiên bản Mẫu',
    comparedToLastMonth: 'So với Tháng trước',
    recentActivity: 'Hoạt động Gần đây',
    viewAll: 'Xem tất cả',
    reportsOverTime: 'Xu hướng Báo cáo',
    completedReports: 'Báo cáo Đã hoàn thành',
    reportsInProgress: 'Báo cáo Đang thực hiện',
    myRecentReports: 'Báo cáo của Tôi',
    createNewReport: 'Tạo Báo cáo Mới',
    monthly: 'Hàng tháng',
    quarterly: 'Hàng quý',
    yearly: 'Hàng năm',
    createdNewReport: 'Đã tạo báo cáo mới',
    updatedReport: 'Đã cập nhật báo cáo',
    createdNewTemplate: 'Đã tạo mẫu mới',

    // Nhãn trạng thái
    draft: 'Bản nháp',
    inProgress: 'Đang thực hiện',
    completed: 'Đã hoàn thành',
    review: 'Đang xem xét',
    archived: 'Đã lưu trữ',

    // Trang quản lý mẫu
    templateManagement: 'Quản lý Mẫu',
    allTemplates: 'Tất cả Mẫu',
    myTemplates: 'Mẫu của Tôi',
    sharedTemplates: 'Mẫu được Chia sẻ',
    createTemplate: 'Tạo Mẫu',
    searchTemplates: 'Tìm kiếm mẫu...',
    templateName: 'Tên Mẫu',
    templateDesc: 'Mô tả Mẫu',
    category: 'Danh mục',
    creator: 'Người tạo',
    createDate: 'Ngày tạo',
    usageCount: 'Số lần Sử dụng',
    version: 'Phiên bản',
    actions: 'Thao tác',
    editTemplate: 'Chỉnh sửa Mẫu',
    duplicateTemplate: 'Sao chép Mẫu',
    deleteTemplate: 'Xóa Mẫu',
    shareTemplate: 'Chia sẻ Mẫu',
    templateCategories: 'Danh mục Mẫu',
    recentlyUsed: 'Sử dụng Gần đây',
    popular: 'Mẫu Phổ biến',
    newest: 'Mẫu Mới nhất',

    // Trang quản lý báo cáo
    reportManagement: 'Quản lý Báo cáo',
    allReports: 'Tất cả Báo cáo',
    myReports: 'Báo cáo của Tôi',
    sharedWithMe: 'Được Chia sẻ với Tôi',
    archivedReports: 'Báo cáo Đã lưu trữ',
    searchReports: 'Tìm kiếm báo cáo...',
    filterByStatus: 'Lọc theo Trạng thái',
    filterByDate: 'Lọc theo Ngày',
    filterByTemplate: 'Lọc theo Mẫu',
    sortBy: 'Sắp xếp theo',
    oldest: 'Cũ nhất',
    lastUpdated: 'Cập nhật Gần đây',
    reportName: 'Tên Báo cáo',
    template: 'Mẫu',
    createdDate: 'Ngày tạo',
    updatedDate: 'Ngày cập nhật',
    status: 'Trạng thái',
    action: 'Thao tác',
    batchActions: 'Thao tác Hàng loạt',
    export: 'Xuất',
    archive: 'Lưu trữ',
    delete: 'Xóa',
    batchDelete: 'Xóa hàng loạt',
    itemsPerPage: 'Số mục mỗi trang',
    prev: 'Trước',
    next: 'Tiếp',
    goToPage: 'Đi đến trang',

    // Chi tiết báo cáo
    reportDetail: 'Chi tiết Báo cáo',
    edit: 'Chỉnh sửa',
    view: 'Xem',
    reportInfo: 'Thông tin Báo cáo',
    basicInfo: 'Thông tin Cơ bản',
    reportContent: 'Nội dung Báo cáo',
    addQuestion: 'Thêm Câu hỏi',
    editQuestion: 'Chỉnh sửa Câu hỏi',
    deleteQuestion: 'Xóa Câu hỏi',
    addAnswer: 'Thêm Câu trả lời',
    saveChanges: 'Lưu Thay đổi',
    cancel: 'Hủy',
    questionCategories: 'Danh mục Câu hỏi',
    allCategories: 'Tất cả Danh mục',
    searchQuestions: 'Tìm kiếm câu hỏi...',
    questionCount: 'Số lượng Câu hỏi',
    answerRate: 'Tỷ lệ Trả lời',
    compare: 'So sánh',
    print: 'In',
    share: 'Chia sẻ',
    comments: 'Bình luận',
    timeline: 'Dòng thời gian',
    activity: 'Hoạt động',

    // Trang tạo báo cáo
    createNewReportLong: 'Tạo Báo cáo Điều tra Mới',
    createReportDesc: 'Vui lòng chọn mẫu báo cáo và điền thông tin cơ bản để tạo báo cáo điều tra mới',
    selectTemplate: 'Chọn Mẫu',
    selectPlanType: 'Chọn Loại Kế hoạch',
    confirmCreate: 'Xác nhận Tạo',
    searchTemplate: 'Tìm kiếm mẫu...',
    nextSelectPlanType: 'Tiếp theo: Chọn Loại Kế hoạch',
    prevSelectTemplate: 'Trước: Chọn Mẫu',
    reportTopicContent: 'Chủ đề và Nội dung Báo cáo',
    nextConfirmCreate: 'Tiếp theo: Xác nhận Tạo',
    prevSelectPlanType: 'Trước: Chọn Loại Kế hoạch',
    confirmReportInfo: 'Xác nhận Thông tin Báo cáo',
    selectedTemplate: 'Mẫu đã Chọn',
    confirmCreateReport: 'Xác nhận Tạo Báo cáo',
    notes: 'Ghi chú',
    note1: 'Sau khi tạo báo cáo, bạn có thể chỉnh sửa và lưu nội dung báo cáo bất cứ lúc nào',
    note2: 'Hệ thống sẽ tự động lưu lịch sử chỉnh sửa và phiên bản của bạn',
    note3: 'Trạng thái báo cáo mặc định là "Bản nháp" sau khi tạo, có thể gửi để xem xét khi hoàn thành',
    plans: 'kế hoạch',
    categories: 'danh mục',
    questions: 'câu hỏi',
    includedCategories: 'Danh mục Bao gồm',
    alreadyCreated: 'Đã tạo',
    createdReports: 'báo cáo',
    madeBy: 'Được tạo bởi',
    system: 'Hệ thống',
    pleaseSelectValidTemplate: 'Vui lòng chọn một mẫu hợp lệ trước',
    pleaseEnter: 'Vui lòng nhập',
    creating: 'Đang tạo...',

    // Liên quan đến thời gian
    today: 'Hôm nay',
    yesterday: 'Hôm qua',
    daysAgo: '{n} ngày trước',
    weeksAgo: '{n} tuần trước',
    unknownDate: 'Ngày không xác định',

    // Giá trị mới
    fullscreen: 'Toàn màn hình',
    confirmLogout: 'Bạn có chắc chắn muốn đăng xuất không?',
    tip: 'Gợi ý',
    confirm: 'Xác nhận',
    cancel: 'Hủy',

    // Module danh sách mẫu
    templatesList: {
        pageTitle: 'Quản lý Mẫu',
        pageSubtitle: 'Quản lý và tổ chức mẫu báo cáo của bạn',
        createTemplate: 'Tạo Mẫu',
        categoryManagement: 'Quản lý Danh mục',
        templateType: 'Loại Mẫu',
        totalTemplates: 'Tổng số Mẫu',
        templateName: 'Tên Mẫu',
        templateDesc: 'Mô tả Mẫu',
        allTemplates: 'Tất cả Mẫu',
        categories: 'Danh mục',
        search: 'Tìm kiếm',
        searchCategories: 'Tìm kiếm danh mục',
        fieldName: 'Tên trường',
        type: 'Loại',
        publishState: 'Trạng thái Xuất bản',
        publish: 'Đã xuất bản',
        unpublish: 'Chưa xuất bản',
        goPublish: 'Xuất bản',
        cancelPublish: 'Hủy Xuất bản',
        creator: 'Người tạo',
        createTime: 'Thời gian Tạo',
        operations: 'Thao tác',
        view: 'Xem',
        noData: 'Không có dữ liệu',
        otherType: 'Loại khác',
        dragSortSuccess: 'Kéo thả sắp xếp thành công, nhấn nút lưu để lưu thay đổi',
        confirmDelete: 'Thao tác này sẽ xóa vĩnh viễn mục này, tiếp tục?',
        tip: 'Gợi ý',
        confirm: 'Xác nhận',
        cancel: 'Hủy',
        deleteSuccess: 'Xóa thành công',
        deleteCancelled: 'Đã hủy xóa',
        nameRequired: 'Tên không được để trống',
        saveSuccess: 'Lưu thành công',
        saveFailed: 'Lưu thất bại',
        createSuccess: 'Tạo thành công',
        createFailed: 'Tạo thất bại',
        pleaseEnter: 'Vui lòng nhập',
        saveChanges: 'Lưu Thay đổi',
        editNote: 'Chỉnh sửa Ghi chú',
        pleaseEnterEditNote: 'Vui lòng nhập ghi chú chỉnh sửa',
        getTemplateListFailed: 'Lấy danh sách mẫu thất bại',
        unsavedChangesTip: 'Bạn đã chỉnh sửa mẫu, thoát bây giờ sẽ hủy các chỉnh sửa hiện tại. Nên lưu trước khi thoát',
        // Ngăn chi tiết mẫu
        templateDetail: 'Chi tiết Mẫu',
        editTemplateInfo: 'Chỉnh sửa Mẫu',
        copyTemplateInfo: 'Sao chép thành Mẫu Mới',
        confirmCopyTemplate: 'Mẫu mới sao chép sẽ thuộc về bạn và không ảnh hưởng đến mẫu hiện có, tiếp tục?',
        description: 'Mô tả',
        noDescription: 'Không có mô tả',
        researchContext: 'Trường Ngữ cảnh Nghiên cứu',
        noContextFields: 'Không có trường ngữ cảnh nghiên cứu',
        reportStructure: 'Cấu trúc Báo cáo',
        addChapter: 'Thêm Chương',
        // Ngăn chỉnh sửa nút
        add: 'Thêm',
        edit: 'Chỉnh sửa',
        parentChapter: 'Chương Cha',
        chapterName: 'Tên Chương',
        subChapterName: 'Tên Chương Con',
        subChapterQuestion: 'Câu hỏi Chương Con',
        chapterPrompt: 'Gợi ý Chương',
        subChapterPrompt: 'Gợi ý Chương Con',
        // Ngăn quản lý danh mục
        categoryManager: 'Quản lý Danh mục',
        addCategory: 'Thêm Danh mục',
        editCategory: 'Chỉnh sửa Danh mục',
        categoryName: 'Tên Danh mục',
        categoryDesc: 'Mô tả Danh mục',
        categoryAdmin: 'Quản trị viên',
        categoryViewer: 'Người xem',
        addAdmin: 'Thêm Quản trị viên',
        addViewer: 'Thêm Người xem',
        selectAdmin: 'Chọn Quản trị viên',
        selectViewer: 'Chọn Người xem',
        sortOrder: 'Thứ tự Sắp xếp',
        categoryCount: 'Số lượng Mẫu',
        categoryActions: 'Thao tác',
        categoryDeleteTip: 'Không thể xóa danh mục có mẫu',
        categorySystemTip: 'Không thể xóa danh mục hệ thống',
        categoryDeleteConfirm: 'Bạn có chắc chắn muốn xóa danh mục này không?',
        categoryDeleteSuccess: 'Xóa danh mục thành công',
        categoryDeleteFailed: 'Xóa danh mục thất bại',
        categorySaveSuccess: 'Lưu danh mục thành công',
        categorySaveFailed: 'Lưu danh mục thất bại',
        categoryCreateSuccess: 'Tạo danh mục thành công',
        categoryOrderUpdateSuccess: 'Cập nhật thứ tự danh mục thành công',
        categoryOrderUpdateFailed: 'Cập nhật thứ tự danh mục thất bại',
        dragSortTip: 'Bạn có thể sử dụng để điều chỉnh thứ tự danh mục',
        deleteTip: 'Chỉ có thể xóa mẫu có số lượng là 0',
        // Biểu mẫu mẫu mới
        newTemplate: 'Mẫu Mới',
        templateTitle: 'Tiêu đề Mẫu',
        templateDesc: 'Mô tả Mẫu',
        researchContextFields: 'Trường Ngữ cảnh Nghiên cứu',
        addField: 'Thêm Trường',
        prompt: 'Gợi ý',
        titleRequired: 'Tên mẫu không được để trống',
        typeRequired: 'Vui lòng chọn danh mục mẫu',
        descRequired: 'Mô tả mẫu không được để trống',
        creatorRequired: 'Người tạo không được để trống',
        // Liên quan đến quyền
        permission: 'Quyền',
        private: 'Chỉ Sử dụng Cá nhân',
        public: 'Công khai trong Danh mục',
        // Gợi ý trạng thái
        loading: 'Đang tải...',
        operationSuccess: 'Thao tác thành công',
        operationFailed: 'Thao tác thất bại',
        getUserPermissionFailed: 'Lấy quyền người dùng thất bại',
        selectCreateMethod: 'Chọn Phương thức Tạo',
        importQuestionList: 'Tạo từ Danh sách Câu hỏi',
        importQuestionListDesc: 'Nhập danh sách câu hỏi, AI sẽ tổ chức chương để tạo mẫu',
        aiGenerateOutline: 'AI Tạo Dàn ý',
        aiGenerateOutlineDesc: 'Sử dụng AI để hoàn thiện mẫu báo cáo thông qua đối thoại',
        manualCreate: 'Tạo Thủ công',
        manualCreateDesc: 'Nhập thông tin cơ bản mẫu, tạo báo cáo có cấu trúc',
        importQuestionListTitle: 'Nhập Danh sách Câu hỏi',
        questionListPlaceholder: `Vui lòng nhập danh sách câu hỏi, mỗi câu hỏi cách nhau bằng dấu xuống dòng. Ví dụ:
Số lượng bệnh nhân Trung Quốc cho chỉ định phát triển mục tiêu, số bệnh nhân có thể chẩn đoán và số bệnh nhân sẽ tìm kiếm điều trị
Ước tính chi phí sản xuất API và công thức, ước tính giá bảo hiểm y tế Trung Quốc
Ước tính doanh số bán hàng của sản phẩm cạnh tranh có cùng mục tiêu và chỉ định ở Trung Quốc, và ước tính doanh số bán hàng có thể đạt được ở Trung Quốc
Có tồn tại tình huống khả năng hợp tác thấp, hoặc rủi ro phát triển lâm sàng cao, hoặc chi phí hợp tác cao, hoặc rủi ro đăng ký cao, hoặc rủi ro bằng sáng chế cao không`,
        confirmRestoreVersion: 'Bạn có chắc chắn muốn khôi phục về phiên bản {version} không?',
        versionHistory: 'Lịch sử Phiên bản',
        currentVersion: 'Phiên bản Hiện tại',
        restoreToThisVersion: 'Khôi phục về phiên bản này',
        modifiedBy: 'Người chỉnh sửa',
        versionRestoreSuccess: 'Khôi phục thành công về phiên bản {version}',
        delete: 'Xóa',
        confirmDelete: 'Xác nhận xóa?',
        deleteFailed: 'Xóa thất bại',
        noVersionHistory: 'Không có lịch sử phiên bản',
        getTemplateTypeFailed: 'Lấy loại mẫu thất bại',
        versionDetail: 'Chi tiết Phiên bản',
        noVersionDetail: 'Không có chi tiết phiên bản',
        changeTemplateStateFailed: 'Thay đổi trạng thái mẫu thất bại',
        versionCount: 'Tổng cộng {count} phiên bản',
        answerType: 'Loại Câu trả lời',
        generalAi: 'AI Tổng quát',
        structuredData: 'Dữ liệu Có cấu trúc',
        pleaseSelect: 'Vui lòng chọn',
        searchMethod: 'Phương thức Tìm kiếm',
        networkSearch: 'Tìm kiếm Mạng',
        aiSearch: 'Tìm kiếm Cục bộ',
        networkSearchTip: 'Tìm kiếm mạng sẽ tìm kiếm thông tin trên internet\nTìm kiếm cục bộ chỉ sử dụng cơ sở kiến thức cục bộ hoặc nội dung tệp',
        presetDatabase: 'Cơ sở Kiến thức Cài đặt sẵn',
        clickToSelect: 'Nhấp để chọn',
        selectPermission: 'Vui lòng chọn quyền',
        promptRequired: 'Gợi ý không được để trống',
        selectKnowledgeBase: 'Chọn Cơ sở Kiến thức',
        deepSearch: 'Chế độ Lập kế hoạch',
        ragSearch: 'RAG tăng cường truy xuất',
        directSearch: 'Truy xuất trực tiếp',
        ragSearchTip: 'Phù hợp với trường hợp dữ liệu tệp lớn, sau khi được mô hình lớn tăng cường truy xuất, chỉ trích xuất nội dung liên quan đến câu hỏi cho AI',
        directSearchTip: 'Chỉ phù hợp khi dữ liệu tệp không nhiều, trích xuất toàn bộ nội dung tệp cho AI',
        aiType: 'Mô hình AI',
    },
    svgMaker: {
        pageTitle: 'Trình tạo Biểu đồ SVG',
        pageSubtitle: 'Sử dụng công nghệ AI để chuyển đổi mô tả văn bản của bạn thành biểu đồ SVG đẹp mắt',
        createButton: 'Tạo Biểu đồ Mới',
        historyTitle: 'Lịch sử',
        recordCount: 'Tổng cộng {count} bản ghi',
        emptyState: 'Không có bản ghi lịch sử',
        generatingStatus: 'Đang tạo',
        viewDetails: 'Xem Chi tiết',
        createDialogTitle: 'Tạo Biểu đồ SVG',
        dialogHeader: 'Tạo Biểu đồ Mới',
        dialogSubtitle: 'Vui lòng nhập mô tả biểu đồ bạn muốn tạo',
        inputDescription: 'Vui lòng mô tả chi tiết biểu đồ bạn muốn, bao gồm loại, kiểu, dữ liệu, v.v.',
        inputPlaceholder: 'Ví dụ: Tạo biểu đồ cột hiển thị dữ liệu bán hàng theo quý năm 2023, sử dụng chủ đề màu xanh',
        demandsToggle: 'Cài đặt Nâng cao',
        demandsCustomTag: 'Tùy chỉnh',
        demandsDescription: 'Bạn có thể thêm yêu cầu tạo chi tiết hơn tại đây',
        demandsPlaceholder: 'Ví dụ: Sử dụng màu gradient, thêm hiệu ứng hoạt hình, điều chỉnh cỡ chữ, v.v.',
        analysisStep: 'Phân tích Yêu cầu',
        extractionStep: 'Trích xuất Thông tin Chính',
        structureStep: 'Xây dựng Cấu trúc Biểu đồ',
        renderingStep: 'Kết xuất SVG',
        generatingTitle: 'Đang tạo biểu đồ...',
        generationSuccess: 'Tạo Biểu đồ Thành công',
        resultTitlePlaceholder: 'Vui lòng nhập tiêu đề biểu đồ',
        regenerateButton: 'Tạo lại',
        downloadButton: 'Tải xuống SVG',
        completeButton: 'Hoàn thành',
        cancel: 'Hủy',
        generateImage: 'Tạo Biểu đồ',
        preparing: 'Đang chuẩn bị...',
        generating: 'Đang tạo...',
        regenerate: 'Tạo lại',
        complete: 'Hoàn thành',
        tip: 'Gợi ý',
        confirm: 'Xác nhận',
        editButton: 'Chỉnh sửa',
        error: {
            minLength: 'Để đảm bảo chất lượng hình ảnh đầu ra, vui lòng nhập ít nhất 20 ký tự',
            createTask: 'Tạo tác vụ thất bại',
            fetchTasks: 'Lấy danh sách tác vụ hình ảnh thất bại',
            generationFailed: 'Tạo hình ảnh thất bại: {message}',
            generationFailedPrefix: 'Tạo thất bại - ',
            saveFailed: 'Lưu thất bại, vui lòng thử lại'
        },
        unnamedChart: 'Biểu đồ Chưa đặt tên',
        currentUser: 'Người dùng Hiện tại',
        imageSaved: 'Đã lưu Hình ảnh',
        generatingChart: 'Đang tạo Biểu đồ...',
        unknownUser: 'Người dùng Không xác định',
        message: {
            enterEditMode: 'Đã vào chế độ chỉnh sửa',
            preparingEditor: 'Đang chuẩn bị trình chỉnh sửa...',
            editorUnavailable: 'Lấy nội dung SVG thất bại, chức năng chỉnh sửa không khả dụng',
            svgContentUnavailable: 'Không thể lấy nội dung SVG, chức năng chỉnh sửa không khả dụng',
            exitEditMode: 'Đã thoát chế độ chỉnh sửa',
            saveSuccess: 'Lưu thành công',
            svgDownloadSuccess: 'Tải xuống SVG thành công',
            svgEncodingFailed: 'Mã hóa SVG thất bại, không thể tải xuống',
            preparingDownload: 'Đang chuẩn bị tải xuống...',
            svgFetchFailed: 'Lấy SVG thất bại',
            svgContentFetchFailed: 'Lấy nội dung SVG thất bại, không thể tải xuống'
        }
    },
    reportsList: {
        pageTitle: 'Quản lý Báo cáo',
        pageSubtitle: 'Quản lý tất cả báo cáo phân tích của bạn',
        createNewReport: 'Tạo Báo cáo Mới',
        reportType: 'Loại Báo cáo',
        reportStatus: 'Trạng thái Báo cáo',
        reportSource: 'Nguồn Báo cáo',
        searchPlaceholder: 'Tìm kiếm tiêu đề hoặc nội dung báo cáo',
        totalReports: 'Tổng số Báo cáo',
        inProgress: 'Đang thực hiện',
        completed: 'Đã hoàn thành',
        view: 'Xem',
        creator: 'Người tạo',
        createTime: 'Thời gian Tạo',
        operations: 'Thao tác',
        noData: 'Không tìm thấy báo cáo phù hợp',
        noDataTip: 'Vui lòng thử điều chỉnh điều kiện lọc hoặc từ khóa tìm kiếm',
        createOptions: {
            title: 'Chọn Phương thức Tạo',
            deepSearch: {
                title: 'Tạo Ngay với Một Câu',
                desc: 'Chỉ cần nhập một câu, tìm kiếm tài liệu thông minh, tạo báo cáo chuyên nghiệp chất lượng cao'
            },
            ai: {
                title: 'Tạo Sau khi Tạo Dàn ý Báo cáo',
                desc: 'Sử dụng AI để hoàn thiện dàn ý báo cáo thông qua đối thoại, sau đó tạo nội dung báo cáo hoàn chỉnh'
            },
            template: {
                title: 'Tạo từ Mẫu Có sẵn',
                desc: 'Chọn mẫu chuyên ngành, nhanh chóng tạo báo cáo có cấu trúc'
            }
        },
        status: {
            notStarted: 'Chưa bắt đầu',
            inProgress: 'Đang thực hiện',
            completed: 'Đã hoàn thành',
            failed: 'Thất bại',
            unknown: 'Không xác định'
        },
        source: {
            normal: 'Báo cáo Thường',
            scheduled: 'Báo cáo Định kỳ',
            system: 'Báo cáo Hệ thống'
        },
        reportTitle: 'Tiêu đề Báo cáo',
        newTag: 'Mới',
        defaultType: 'Báo cáo AI'
    },
    reportDetailModule: {
        loadingText: "Đang tải chi tiết báo cáo",
        confirmText: "Nếu bạn thấy câu trả lời này hữu ích, vui lòng nhấn nút xác nhận, tôi sẽ cập nhật phần này với câu trả lời trên.\n\n <Cập nhật vào phần này>",
        download: "Tải xuống",
        downloading: "Đang tải xuống",
        saveToKnowledge: "Lưu vào Cơ sở Kiến thức",
        reportType: "Loại Báo cáo",
        template: "Mẫu",
        creator: "Người tạo",
        createTime: "Thời gian Tạo",
        reportId: "Mã Báo cáo",
        aiModel: "Mô hình AI",
        temperature: "Nhiệt độ",
        researchBackground: "Bối cảnh Nghiên cứu",
        reportSections: "Phần Báo cáo",
        aiSuggestions: "AI Sửa đổi",
        aiFeedbackAssistant: "Trợ lý Phản hồi AI",
        you: "Bạn",
        from: "Từ",
        generating: "Đang tạo",
        confirmGenerate: "Xác nhận Tạo",
        inputPlaceholder: "Vui lòng nhập nội dung để giao tiếp với AI",
        status: {
            notStarted: "Chưa bắt đầu",
            inProgress: "Đang thực hiện",
            completed: "Đã hoàn thành",
            failed: "Thất bại",
            unknown: "Không xác định"
        },
        error: {
            fetchFailed: "Lấy chi tiết báo cáo thất bại",
            fetchAiModelsFailed: "Lấy mô hình AI thất bại",
            downloadLinkInvalid: "Liên kết tải xuống không hợp lệ",
            updateFailed: "Cập nhật thất bại",
            saveToKnowledgeFailed: "Lưu vào cơ sở kiến thức thất bại",
            fetchChatMessagesFailed: "Lấy tin nhắn trò chuyện thất bại",
            startChatFailed: "Bắt đầu phiên trò chuyện thất bại",
            generationFailed: "Tạo chương thất bại",
            errorCount: "Hiện tại có {count} chương chưa được tạo",
            retryFailed: "Tạo lại tác vụ thất bại"
        },
        success: {
            updateSuccess: "Cập nhật thành công",
            saveToKnowledgeSuccess: "Lưu vào cơ sở kiến thức thành công",
            retrySuccess: "Tác vụ tạo lại đã được khởi động"
        },
        aiAssistant: "Trợ lý AI",
        welcomeMessage: "Xin chào! Tôi là trợ lý phản hồi AI, tôi có thể giúp bạn phân tích và cải thiện nội dung [{section}] trong báo cáo này. Tôi có thể giúp gì cho bạn?",
        thinking: "Đang suy nghĩ",
        nextChapter: "Chương tiếp theo",
        clickToContinue: "Nhấp để tiếp tục đọc",
        lastChapter: "Đây là chương cuối cùng",
        cancel: "Hủy",
        save: "Lưu",
        edit: "Chỉnh sửa",
        unknownModel: "Mô hình không xác định",
        confirmEditDiscard: "Bạn có nội dung đang chỉnh sửa, hủy bỏ các chỉnh sửa trước đó?",
        prompt: "Gợi ý",
        discard: "Hủy bỏ",
        share: 'Chia sẻ',
        shareSuccess: 'Đã sao chép liên kết chia sẻ vào clipboard',
        shareFailed: 'Sao chép liên kết chia sẻ thất bại',
        versionHistory: 'Lịch sử Phiên bản',
        retry: 'Tạo lại',
        retrying: 'Đang tạo lại',
      },
      versionList: {
        title: 'So sánh Phiên bản',
        baseVersion: 'Phiên bản Cơ sở',
        selectVersionToCompare: 'Chọn phiên bản để so sánh',
        compare: 'So sánh',
        clearCompareVersion: 'Xóa phiên bản so sánh',
        selectVersion: 'Chọn phiên bản',
        latestVersion: 'Phiên bản Mới nhất',
        version: 'Phiên bản',
        reviser: 'Người sửa đổi',
      },
    createReport: {
        steps: ['Chọn Danh mục Báo cáo', 'Chọn Mẫu Báo cáo', 'Điền Nội dung Báo cáo', 'Xác nhận Thông tin Báo cáo'],
        sectionTitle: 'Chọn Danh mục Báo cáo',
        sectionDesc: 'Vui lòng chọn loại báo cáo bạn cần tạo',
        typeBadge: 'mẫu',
        footerStat: 'Đã tạo',
        footerStat2: 'báo cáo',
        subsectionTitle: 'Chọn Mẫu',
        subsectionDesc: 'Danh mục đã chọn:',
        fillContentTitle: 'Điền Nội dung Báo cáo',
        fillContentDesc: 'Mẫu đã chọn:',
        templateMeta: 'và',
        templateMeta2: 'mô-đun phân tích',
        moreSettings: 'Cài đặt Thêm',
        temperatureHint: 'Nhiệt độ cao hơn làm cho nội dung được tạo bởi AI sáng tạo hơn, nhiệt độ thấp hơn làm cho kết quả xác định và dự đoán hơn',
        aiModelHint: 'Các mô hình AI khác nhau có đặc điểm riêng về sáng tạo, tốc độ và hiệu quả',
        confirmTitle: 'Xác nhận Thông tin Báo cáo',
        confirmDesc: 'Vui lòng xác nhận thông tin sau trước khi tạo báo cáo',
        confirmSection1: 'Loại Báo cáo',
        confirmSection2: 'Nội dung Báo cáo',
        confirmSection3: 'Nội dung Phân tích Báo cáo',
        reportAnalysisTitle: 'Nội dung Phân tích Báo cáo',
        associatedKnowledge: 'Kiến thức đã liên kết',
        srcType: {
            knowledgeBase: 'AI Tổng quát',
            deepSearch: 'Chế độ Lập kế hoạch',
            mcp: 'MCP',
            custom: 'Dữ liệu Có cấu trúc'
        },
        confirmSection4: 'Cài đặt Tạo AI',
        confirmLabel1: 'Danh mục:',
        confirmLabel2: 'Mẫu:',
        confirmLabel3: 'Mô tả:',
        confirmLabel4: 'Mô hình AI:',
        confirmLabel5: 'Nhiệt độ:',
        noticeTitle: 'Lưu ý',
        notice1: 'Sau khi tạo báo cáo, bạn có thể chỉnh sửa và lưu nội dung báo cáo bất cứ lúc nào',
        notice2: 'Hệ thống sẽ tự động lưu lịch sử chỉnh sửa và phiên bản của bạn',
        notice3: 'Việc tạo báo cáo cần thời gian, trạng thái mặc định là "Đang thực hiện", vui lòng chờ đợi hoàn thành',
        prevStep: 'Trước',
        nextStep: 'Tiếp',
        createReport: 'Xác nhận Tạo Báo cáo',
        creating: 'Đang tạo...',
        error1: 'Lấy loại mẫu thất bại',
        error2: 'Lấy mô hình AI thất bại',
        error3: 'Lấy mẫu thất bại',
        error4: 'Vui lòng hoàn thành tất cả nội dung báo cáo trước khi tiếp tục',
        success: 'Tạo báo cáo thành công!',
        error5: 'Tạo báo cáo thất bại, vui lòng thử lại',
        temperature: 'Nhiệt độ',
        aiModel: 'Mô hình AI',
        selectAiModel: 'Vui lòng chọn mô hình AI',
        opportunityOverview: 'Tổng quan Cơ hội',
        opportunityOverviewRequired: 'Vui lòng nhập tổng quan cơ hội',
        opportunityOverviewPlaceholder: 'Bạn có thể nhập thông tin đã biết hoặc ghi chú liên quan cho báo cáo này, hoặc điền "không" nếu không cần thiết',
        unknownModel: 'Mô hình không xác định',
        fieldRequired: 'Vui lòng nhập {field}',
        fieldPlaceholder: 'Vui lòng nhập {field}'
        ,
        // Bổ sung khu vực phân tích mẫu
        analysisQuestions: '{count} câu hỏi phân tích',
        associateKnowledgeBtn: 'Liên kết Kiến thức',
        notSupported: 'Không hỗ trợ',
        selectKnowledgeBase: 'Chọn Cơ sở Kiến thức',
        myCreatedTag: 'Tôi tạo',
        noNeedToFill: 'Không cần điền nội dung',
        reportTitle: 'Tiêu đề Báo cáo',
        reportTitlePlaceholder: 'Vui lòng nhập tiêu đề báo cáo, nếu không điền sẽ tự động tạo'
    },
    aiChat: {
        chatTitle: 'Tạo Sau khi AI Tạo Dàn ý',
        deepSearchTitle: 'Tạo Tức thì bằng AI',
        closeConfirm: 'Bạn chưa hoàn thành cuộc trò chuyện với Trợ lý Thông tin AI, bạn có chắc chắn muốn thoát không?',
        closeReportConfirm: 'Bạn chưa tạo báo cáo, bạn có chắc chắn muốn thoát không?',
        inputPlaceholder: 'Vui lòng nhập nội dung để giao tiếp với Thông tin AI',
        confirmGenerate: 'Xác nhận Tạo',
        thinking: 'Đang suy nghĩ',
        fullscreen: 'Toàn màn hình',
        exitFullscreen: 'Thoát Toàn màn hình',
        close: 'Đóng',
        generatingReport: 'Đang tạo Báo cáo AI...',
        reportInitialized: 'Dàn ý báo cáo đã được khởi tạo thành công',
        goGenerate: 'Đi tạo',
        cancel: 'Hủy',
        generating: 'Đang tạo...',
        reportStructure: 'Cấu trúc Nội dung Báo cáo',
        cancelReport: 'Bạn đã hủy tạo báo cáo. Để tiếp tục, vui lòng cho tôi biết yêu cầu của bạn.',
        error: 'Đã xảy ra lỗi',
        sendError: 'Gửi tin nhắn thất bại, vui lòng thử lại',
        initError: 'Khởi tạo phiên thất bại, vui lòng thử lại',
        getTemplateError: 'Lấy dữ liệu mẫu thất bại, vui lòng thử lại',
        unknownModel: 'Mô hình không xác định',
        you: 'Bạn',
        aiAssistant: 'Trợ lý Thông tin AI',
        introText: 'Xin chào! Tôi là Trợ lý Thông tin AI, tôi có thể giúp bạn tạo báo cáo. Vui lòng cho tôi biết bạn muốn tạo báo cáo gì, tôi sẽ làm việc với bạn để hoàn thiện dàn ý báo cáo trước khi tạo báo cáo.',
        deepSearchIntroText: 'Xin chào! Tôi là Trợ lý Thông tin AI, từ giải đáp cuộc sống đến kiến thức chuyên môn, từ ý tưởng sáng tạo đến lập kế hoạch nhiệm vụ, tôi có thể xử lý tất cả! Nhập từ khóa hoặc câu hỏi cụ thể để ngay lập tức mở khóa dịch vụ thông minh hiệu quả và chính xác.',
        templateIntroText: 'Xin chào! Tôi là Trợ lý Thông tin AI, tôi có thể giúp bạn tạo mẫu. Vui lòng cho tôi biết bạn muốn tạo mẫu gì, tôi sẽ làm việc với bạn để hoàn thiện dàn ý mẫu trước khi tạo mẫu.',
        missingParams: 'Thiếu tham số tạo báo cáo',
        reportCreated: 'Tạo báo cáo thành công!',
        reportCreateError: 'Tạo báo cáo thất bại, vui lòng thử lại',
        tip: 'Gợi ý',
        confirm: 'Xác nhận',
        generateTemplate: 'Tạo Mẫu',
        selectTemplate: 'Chọn Loại Mẫu',
        templateType: 'Loại Mẫu',
        selectTemplateType: 'Vui lòng chọn loại mẫu',
        templateCreated: 'Tạo mẫu thành công',
        templateCreateError: 'Tạo mẫu thất bại',
        getTemplateTypesError: 'Lấy loại mẫu thất bại',
        reportTaskCreated: 'Tạo báo cáo thành công',
        userPaused: 'Người dùng đã tạm dừng',
        newChatConfirmPC: 'Bạn chưa hoàn thành cuộc trò chuyện với trợ lý AI. Bạn có chắc chắn muốn bắt đầu một cuộc trò chuyện mới không?',
        newChatConfirmMobileWithReport: 'Bạn có chắc chắn muốn bắt đầu một cuộc trò chuyện mới không? Báo cáo hiện tại có thể được xem trong danh sách báo cáo.',
        newChatConfirmMobileNoReport: 'Bạn chưa hoàn thành cuộc trò chuyện với trợ lý AI. Cuộc trò chuyện hiện tại sẽ bị mất. Bạn có chắc chắn muốn bắt đầu một cuộc trò chuyện mới không?',
        timeFormat: {
            month: '/',
            day: ' ',
            timeSeparator: ':'
        },
        latestChat: 'Đây Là Cuộc Trò Chuyện Mới Nhất',
        chatCompleted: 'Cuộc trò chuyện AI hiện tại đã hoàn thành. Nhấp vào',
        newChat: 'Mới'
    },
    addGroup: {
        title: 'Thiết lập Nhóm',
        commonContacts: 'Liên hệ Thường xuyên',
        people: 'Người',
        createNewGroup: 'Tạo Nhóm Mới',
        cancel: 'Hủy',
        confirm: 'Xác nhận',
        newGroupTitle: 'Tạo Nhóm Mới',
        enterGroupName: 'Vui lòng nhập tên nhóm',
        selectCategory: 'Vui lòng chọn danh mục',
        category: 'Danh mục',
        groupNameRequired: 'Vui lòng nhập tên nhóm',
        addToGroupSuccess: 'Thêm vào nhóm thành công',
        addToGroupFailed: 'Thêm vào nhóm thất bại',
        createGroupSuccess: 'Tạo nhóm thành công',
        createGroupFailed: 'Tạo nhóm thất bại'
    },
    leftArea: {
        searchPlaceholder: 'Tìm kiếm tên, pinyin, chức danh...',
        noSearchResults: '-Không có kết quả tìm kiếm-',
        leaveStatus: '(Đã nghỉ việc)',
        commonContacts: 'Liên hệ Thường xuyên',
        recentContacts: 'Liên hệ Gần đây',
        commonContact: 'Liên hệ Thường xuyên',
        recentContact: 'Liên hệ Gần đây',
        setGroup: 'Thiết lập Nhóm',
        setAsCommonContact: 'Đặt làm Liên hệ Thường xuyên',
        operationSuccess: 'Thao tác thành công',
        alreadyAdded: 'Đã thêm, vui lòng không lặp lại',
        limitExceeded: 'Chỉ được phép thêm {count} người',
        duplicateSelection: 'Không thể chọn trùng lặp',
        noDuplicateSelection: 'Không thể chọn trùng lặp',
        people: 'Người'
    },
    rightArea: {
        title: 'Khu vực Phải',
        searchPlaceholder: 'Tìm kiếm',
        selectAll: 'Chọn Tất cả',
        setGroup: 'Thiết lập Nhóm',
        noSelection: 'Vui lòng chọn mục trước',
        operationSuccess: 'Thao tác thành công',
        setCommonContact: 'Đặt làm Liên hệ Thường xuyên',
        removeCommonContact: 'Xóa khỏi Liên hệ Thường xuyên',
        myGroup: 'Nhóm của Tôi',
        maxDeptLimit: 'Chỉ được phép thêm {max} phòng ban',
        maxPeopleLimit: 'Chỉ được phép thêm {max} người',
        alreadyAdded: 'Đã thêm, vui lòng không lặp lại',
        alreadyRemoved: 'Đã xóa, vui lòng không lặp lại',
        expand: 'Mở rộng',
        retract: 'Thu gọn',
        rename: 'Đổi tên',
        nextLevel: 'Cấp tiếp theo',
        people: 'Người'
    },
    svgEditor: {
        title: 'Chế độ chỉnh sửa SVG',
        subtitle: 'Thêm, chỉnh sửa hoặc xóa văn bản và kéo để thay đổi vị trí',
        addText: 'Thêm văn bản',
        removeSelected: 'Xóa mục đã chọn',
        resetBackground: 'Khôi phục',
        exitEdit: 'Thoát chỉnh sửa',
        save: 'Lưu',
        undo: 'Hoàn tác',
        redo: 'Làm lại',
        zoomLabel: 'Thu phóng',
        resetZoom: 'Đặt lại',
        fontSize: 'Cỡ chữ',
        fontFamily: 'Phông chữ',
        color: 'Màu sắc',
        charSpacing: 'Giãn cách chữ',
        lineHeight: 'Giãn dòng',
        textAlign: 'Căn chỉnh',
        alignLeft: 'Trái',
        alignCenter: 'Giữa',
        alignRight: 'Phải',
        alignSelection: 'Căn thẳng',
        multiAlignTitle: 'Căn chỉnh nhiều đối tượng',
        alignLeftEdge: 'Căn trái',
        alignHCenter: 'Căn giữa ngang',
        alignRightEdge: 'Căn phải',
        alignTopEdge: 'Căn trên',
        alignVCenter: 'Căn giữa dọc',
        alignBottomEdge: 'Căn dưới',
        enterFullscreen: 'Toàn màn hình',
        exitFullscreen: 'Thoát toàn màn hình',
        textPanelTitle: 'Thuộc tính văn bản',
        textPlaceholder: 'Chỉnh sửa nội dung trực tiếp tại đây',
        preview: 'Xem trước',
        download: 'Tải xuống',
        previewTitle: 'Xem trước canvas',
        previewPlaceholder: 'Đang tạo xem trước...',
        previewClose: 'Đóng',
        previewFailed: 'Tạo xem trước thất bại',
        downloadSuccess: 'Đã bắt đầu tải xuống',
        downloadFailed: 'Tải xuống thất bại, vui lòng thử lại',
        defaultText: 'Nhấp đúp để chỉnh sửa văn bản',
        confirmExit: 'Bạn có chắc muốn hủy mọi thay đổi và khôi phục trạng thái ban đầu không?',
        confirm: 'Xác nhận',
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        successMessage: 'Đã khôi phục về trạng thái ban đầu',
        saveError: 'Lưu thất bại, vui lòng thử lại',
    },
    database: {
        title: 'Quản lý Cơ sở Dữ liệu',
        subtitle: 'Trên trang này, bạn có thể quản lý và xem thông tin cơ sở dữ liệu',
        addRecord: 'Thêm Bản ghi',
        removeRecord: 'Xóa Bản ghi',
        save: 'Lưu',
        cancel: 'Hủy',
        confirm: 'Xác nhận',
        searchPlaceholder: 'Tìm kiếm cơ sở dữ liệu...',
        confirmDelete: 'Bạn có chắc chắn muốn xóa bản ghi này không?',
        successMessage: 'Thao tác thành công',
        errorMessage: 'Thao tác thất bại, vui lòng thử lại',
        goToPage: 'Đi đến trang',
        page: 'trang',
        preview: 'Xem trước',
        subFolder: 'Cấp dưới',
        selectedCount: 'Đã chọn',
        item: 'mục',
        maxSelect: 'Lựa chọn tối đa',
        knowledgeBase: 'Cơ sở Kiến thức',
        created: 'Đã tạo',
    },
    onelineReportPage: {
        historyPanel: 'Phiên Lịch Sử',
        newButton: 'Mới',
        noResult: 'Không Có Kết Quả',
        loadMore: 'Cuộn Để Tải Thêm',
        noMoreData: 'Không Còn Dữ Liệu',
        loading: 'Đang Tải',
        userTitle: 'Bạn',
        aiTitle: 'Trợ Lý AI',
        getHistoryFailed: 'Không Thể Lấy Lịch Sử',
        stateMap: {
            0: 'Chưa Bắt Đầu',
            1: 'Đang Tiến Hành',
            2: 'Hoàn Thành',
            3: 'Thất Bại'
        },
        emptyHistory: 'Không Có Lịch Sử',
        aiAssistant: 'Trợ Lý AI',
        timeFormat: {
            month: '/',
            day: ' ',
            timeSeparator: ':'
        },
        latestChat: 'Đây là cuộc trò chuyện mới nhất',
        chatCompletedPrefix: 'Cuộc trò chuyện thông minh hiện tại đã hoàn thành, vui lòng nhấp vào',
        deleteSessionConfirm: 'Bạn có chắc chắn muốn xóa phiên "{name}" không?',
        deleteSessionTitle: 'Xác nhận',
        deleteSessionConfirmBtn: 'Xác nhận',
        deleteSessionCancelBtn: 'Hủy',
        deleteSuccess: 'Xóa thành công',
        deleteFailed: 'Xóa thất bại',
        deleteFailedRetry: 'Xóa thất bại, vui lòng thử lại'
    },
    feedback: {
        button: 'Có đề xuất? Nhấp để phản hồi',
        title: 'Giúp chúng tôi cải thiện hệ thống! Phản hồi của bạn là động lực để tiến bộ~',
        placeholder: 'Gặp vấn đề? Có yêu cầu mới? Vui lòng cung cấp thông tin chi tiết, chúng tôi sẽ xử lý nhanh chóng~ Hãy cung cấp thông tin càng chi tiết càng tốt để giúp chúng tôi xác định vấn đề nhanh hơn, ví dụ như tiêu đề báo cáo, chức năng sử dụng, v.v.',
        cancel: 'Hủy',
        submit: 'Gửi ngay',
        success: 'Cảm ơn phản hồi của bạn!',
        error: 'Gửi phản hồi thất bại, vui lòng thử lại sau'
    },
    intelligenceQueryPage: {
        inputPlaceholder: 'Vui lòng nhập câu hỏi của bạn...',
        generating: 'Đang tạo',
        errorAiService: 'Lỗi dịch vụ AI, vui lòng thử lại sau.',
    },
} 